import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {Col, FormGroup, Input, Label, Row} from 'reactstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {Validacao} from "../../../comum/components/Validacao";
import Select from "react-select";
import {createSelectOptions} from "../../../../utils/formatar";
import DatePicker from "react-datepicker";
import moment from "moment";

@inject("store")
@observer
export class DadosTerminoAntecipadoForm extends Component {

    static propTypes = {
        controller: PropTypes.object
    };

    constructor(props) {
        super(props);
        this.loginStore = this.props.store.loginStore;
    }

    render() {
        const razaoTerminoAntecipado = this.props.controller.solicitacaoMudancaPrazo.razaoAlteracao;
        const razaoOptions = createSelectOptions(this.props.controller.motivosTerminoAntecipado, "nome", "nome");
        const novaDataInicialEditavel = this.props.controller.novaDataInicialEditavel;
        const momentDataTerminoAntecipado = this.props.controller.momentDataTerminoAntecipado;
        const momentDataTermino = _.get(this.props.controller, "solicitacao.momentDataTermino");
        const momentAntesDataTermino = this.props.controller.momentAntesDataTermino;
        let momentDepoisDataInicio = this.props.controller.momentDepoisDataInicio;
        const dataInicio = moment(_.get(this.props.controller, "solicitacao.dataInicio")).format("DD/MM/YYYY");

        if(!this.loginStore.isPerfilAdministradorLogado) {
            if(moment().isAfter(momentDepoisDataInicio))
                momentDepoisDataInicio = moment()
        }

        // validação da data de termino para quem não for administrador.
        const validacaoTipo = ["isRequired", "isDate"];
        if (!this.loginStore.isPerfilAdministradorLogado) {
            validacaoTipo.unshift("endDateSame", dataInicio);
        }

        return (
            <div>
                <h4>Término antecipado</h4>
                <Row>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Razão término <sup>*</sup></Label>
                            <Select simpleValue value={razaoTerminoAntecipado}
                                    options={razaoOptions}
                                    onChange={(value) => this.props.controller.setRazaoTerminoAntecipado(value)}
                                    noResultsText="Nenhum resultado encontrado" placeholder="Selecione..."
                                    multi={false}/>
                            <Validacao id="razaoTerminoAntecipado" valor={razaoTerminoAntecipado} tipo={["isRequired"]}/>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Data final antecipada <sup>*</sup></Label>
                            <DatePicker
                                ref="dataFim"
                                onClickOutside={()=>{this.refs.dataFim.cancelFocusInput(); this.refs.dataFim.setOpen(false);}}
                                locale={"pt_BR"}
                                className="form-control"
                                dateFormat="DD/MM/YYYY"
                                selectsStart
                                selected={momentDataTerminoAntecipado}
                                startDate={momentDepoisDataInicio}
                                minDate={momentDepoisDataInicio}
                                maxDate={momentAntesDataTermino}
                                onChange={(value) => this.props.controller.setDataTerminoAntecipado(value)}
                                onBlur={(e) => this.props.controller.setDataTerminoAntecipadoCheck(e.target.value)}
                            />
                            <Validacao id="dataTerminoAntecipado" valor={this.props.controller.dataTerminoAntecipadoValidacao}
                                       tipo={validacaoTipo}/>
                        </FormGroup>
                    </Col>
                </Row>
            </div>
        )
    }
}